import { LotoConclusionSearchRequest } from 'api/LotoConclusionSearchRequest';
import { LotoLogSearchRequest } from 'api/LotoLogSearchRequest';
import { LotoPermissionSearchRequest } from 'api/LotoPermissionSearchRequest';
import { LotoSettingSearchRequest } from 'api/LotoSettingSearchRequest';
import { SearchRequest } from 'api/SearchRequest';

export const dashboardKeys = {
  detail: ['dashboard'] as const,
};
export const mapDashboardKeys = {
  all: ['maPDashboard'] as const,
};

export const mapEquipKeys = {
  all: ['maPDashboard'] as const,
};

export const plantImageKeys = {
  all: ['plantImage'] as const,
};

export const lotoConclusionKeys = {
  all: ['lotoConclusion'] as const,
  list: (filters: LotoConclusionSearchRequest) =>
    [
      'lotoConclusion',
      'list',
      { page: filters.page, count: filters.count, factoryCode: filters.factoryCode },
    ] as const,
  details: () => [...lotoConclusionKeys.all, 'detail'] as const,
  detail: (id: number) => [...lotoConclusionKeys.details(), id] as const,
};

export const permissionTransferKeys = {
  all: ['lotoPermissions'] as const,
  list: (filters: LotoPermissionSearchRequest) =>
    [
      'lotoPermissions',
      'list',
      {
        manualYn: filters.manualYn,
        page: filters.page,
        count: filters.count,
        completeYn: filters.completeYn,
      },
    ] as const,
};

export const lotoCommunicationKeys = {
  all: ['lotoCommunication'] as const,
  list: (filters: LotoConclusionSearchRequest) =>
    [
      'lotoCommunication',
      'list',
      { page: filters.page, count: filters.count },
    ] as const,
};

export const lotoActionLogKeys = {
  all: ['lotoActionLog'] as const,
  list: (filters: LotoConclusionSearchRequest) =>
    [
      'lotoActionLog',
      'list',
      { page: filters.page, count: filters.count },
    ] as const,
};

export const lotoSettingKeys = {
  all: ['lotoSettings'] as const,
  list: (filters: LotoSettingSearchRequest) =>
    [
      'lotoSettings',
      'list',
      { page: filters.page, count: filters.count, factoryCode: filters.factoryCode },
    ] as const,
};

export const lotoBoxKeys = {
  all: ['lotoBoxes'] as const,
  list: (filters: LotoSettingSearchRequest) =>
    [
      'lotoBoxes',
      'list',
      { page: filters.page, count: filters.count, factoryCode: filters.factoryCode },
    ] as const,
};

export const lotoLogKeys = {
  all: ['lotoLogs'] as const,
  list: (filters: LotoLogSearchRequest) =>
    ['lotoLogs', 'list', { page: filters.page, count: filters.count, factoryCode: filters.factoryCode }] as const,
  details: () => [...lotoLogKeys.all, 'detail'] as const,
  detail: (id: number) => [...lotoLogKeys.details(), id] as const,
};

export const lotoPermissionKeys = {
  all: ['lotoPermissions'] as const,
  list: (filters: LotoPermissionSearchRequest) =>
    [
      'lotoPermissions',
      'list',
      {
        factoryCode: filters.factoryCode,
        manualYn: filters.manualYn,
        page: filters.page,
        count: filters.count,
        completeYn: filters.completeYn,
      },
    ] as const,
};

export const lotoActionKeys = {
  all: ['lotoActions'] as const,
  list: (orderId: number, filters: SearchRequest) => [
    lotoActionKeys.all,
    'list',
    { orderId, page: filters.page, count: filters.count },
  ],
};

export const lockerKeys = {
  all: ['lockers'] as const,
  list: (filters: LotoConclusionSearchRequest) =>
    ['lockers', 'list', { page: filters.page, count: filters.count }] as const,
  details: () => [...lockerKeys.all, 'detail'] as const,
  detail: (id: number) => [...lockerKeys.details(), id] as const,
};

export const factoryKeys = {
  all: ['factories'] as const,
  details: () => [...factoryKeys.all, 'detail'] as const,
  detail: (id: number) => [...factoryKeys.details(), id] as const,
};
export const factoryCodeKeys = {
  all: ['factoryCodes'] as const,
  details: () => [...factoryCodeKeys.all, 'detail'] as const,
  detail: (id: number) => [...factoryCodeKeys.details(), id] as const,
};

export const partKeys = {
  all: ['parts'] as const,
  list: (factoryId: string) => ['parts', 'list', { factoryId }] as const,
  details: () => [...partKeys.all, 'detail'] as const,
  detail: (id: number) => [...partKeys.details(), id] as const,
};

export const zoneKeys = {
  all: ['zones'] as const,
  list: (partId: number) => ['zones', 'list', { partId }] as const,
  listByFactory: (factoryId: string) =>
    ['zones', 'list', 'factory', { factoryId }] as const,
  details: () => [...zoneKeys.all, 'detail'] as const,
  detail: (id: number) => [...zoneKeys.details(), id] as const,
};

export const sectionKeys = {
  all: ['sections'] as const,
  list: (zoneId: number) => ['sections', 'list', { zoneId }] as const,
  listByFactory: (factoryId: string) =>
    ['sections', 'list', 'factory', { factoryId }] as const,
  details: () => [...sectionKeys.all, 'detail'] as const,
  detail: (id: number) => [...sectionKeys.details(), id] as const,
};

export const deviceKeys = {
  all: ['devices'] as const,
  list: (sectionId: number) => ['devices', 'list', { sectionId }] as const,
  details: () => [...deviceKeys.all, 'detail'] as const,
  detail: (id: number) => [...deviceKeys.details(), id] as const,
};
export const equipQrKeys = {
  all: ['equipsQr'] as const,
};

export const adminKeys = {
  all: ['admins'] as const,
  list: (filters: SearchRequest) => ['admins', 'list', { ...filters }] as const,
  details: () => [...adminKeys.all, 'detail'] as const,
  detail: (id: number) => [...adminKeys.details(), id] as const,
};

export const departKeys = {
  all: ['departs'] as const,
  details: () => [...departKeys.all, 'detail'] as const,
  detail: (id: number) => [...departKeys.details(), id] as const,
};

export const userInfoKeys = {
  all: ['useInfos'] as const,
  list: (filters: LotoConclusionSearchRequest) =>
    ['useInfos', 'list', { page: filters.page, count: filters.count }] as const,
  details: () => [...userInfoKeys.all, 'detail'] as const,
  detail: (id: number) => [...userInfoKeys.details(), id] as const,
};

export const userAuthKeys = {
  all: ['userAuths'] as const,
  list: (filters: SearchRequest) =>
    [
      'userAuths',
      'list',
      { page: filters.page, count: filters.count },
    ] as const,
  details: () => [...userAuthKeys.all, 'detail'] as const,
  detail: (id: number) => [...userAuthKeys.details(), id] as const,
};

export const shiftWorkKeys = {
  all: ['shiftWorkKeys'] as const,
  list: (filters: SearchRequest) =>
    [
      'shiftWorkKeys',
      'list',
      { page: filters.page, count: filters.count },
    ] as const,
  details: () => [...userAuthKeys.all, 'detail'] as const,
  detail: (id: number) => [...userAuthKeys.details(), id] as const,
}
